<template>
  <Modal
    :title="title"
    :show.sync="forms.show"
    @cancel="forms.show = false"
    @submit="Save"
  >
    <div
      style="width:1000px; display:flex"
      :style="{ 'min-height': forms.isPotensi ? '350px' : '500px' }"
    >
      <div
        style="width:300px; height:300px; background:silver; margin-right:10px;"
      >
        <Map
          :strval.sync="forms.Lokasi"
          :lon.sync="forms.Lon"
          :lat.sync="forms.Lat"
          :layers="[
            {
              name: 'lokasi',
              type: 'linestring',
              points: forms.LokasiAsset,
              focus: true,
            },
          ]"
          :zoom="16"
          width="300px"
          height="300px"
        />
        <div
          style="border-bottom: 1px solid silver; display:flex"
          v-if="!forms.isPotensi"
        >
          <v-btn text color="primary" @click="tab = 'detail'">
            DETAIL POTENSI
          </v-btn>
        </div>
        <div
          style="border-bottom: 1px solid silver; display:flex"
          v-if="forms.AssetId && !forms.isPotensi"
        >
          <v-btn text color="primary" @click="tab = 'foto'">
            FOTO
          </v-btn>
        </div>
        <div
          style="border-bottom: 1px solid silver; display:flex"
          v-if="forms.AssetId && !forms.isPotensi"
        >
          <v-btn text color="primary" @click="tab = 'rekanan'">
            REKANAN
          </v-btn>
        </div>
        <div
          style="border-bottom: 1px solid silver; display:flex"
          v-if="forms.AssetId && !forms.isPotensi"
        >
          <MenuButton
            :items="[
              { text: 'Berita Acara' },
              { text: 'Rekomendasi Teknis' },
              { text: 'Perjanjian Kerja Sama' },
            ]"
            @click="DownloadDoc"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="primary" v-on="on">
                DOKUMEN
              </v-btn>
            </template>
          </MenuButton>
        </div>
      </div>
      <div v-show="tab == 'foto'">
        <Uploader
          :value.sync="forms.Foto1"
          accept=".jpg,.png"
          style="display:inline-block;"
        ></Uploader>
        <Uploader
          :value.sync="forms.Foto2"
          accept=".jpg,.png"
          style="display:inline-block;"
        ></Uploader>
        <Uploader
          :value.sync="forms.Foto3"
          accept=".jpg,.png"
          style="display:inline-block;"
        ></Uploader>
        <Uploader
          :value.sync="forms.Foto4"
          accept=".jpg,.png"
          style="display:inline-block;"
        ></Uploader>
      </div>
      <div class="form-inline" style="width:500px" v-show="tab == 'detail'">
        <Search
          label="Asset"
          dbref="AST_SrcAsset"
          width="300px"
          :value.sync="forms.AssetId"
        />
        <Input
          type="text"
          label="Nama Potensi"
          width="300px"
          :value.sync="forms.NamaPotensi"
          remarks="Beri nama yang mudah dibedakan, ex: INDOMARET KESATRIAN"
        />
        <Select
          label="Tipe"
          width="300px"
          :value.sync="forms.JenisPenerimaan"
          dbref="AST_SelKategori"
        />
        <Select
          label="Sub Tipe"
          width="300px"
          :value.sync="forms.SubJenis"
          :items="[
            { val: 'SPBU', txt: 'SPBU' },
            { val: 'BANK', txt: 'BANK' },
            { val: 'MINIMARKET', txt: 'MINIMARKET' },
            { val: 'REKLAME', txt: 'REKLAME' },
            { val: 'LAINNYA', txt: 'LAINNYA' },
          ]"
        />
        <TextArea label="Alamat" width="300px" :value.sync="forms.Alamat" />
        <Select
          label="Kabupaten"
          width="300px"
          :value.sync="forms.Kabupaten"
          dbref="MST_SelKabupaten"
        />
        <Input
          type="text"
          label="Koordinat"
          placeholder="Contoh : -7.0999785,110.2579122"
          width="300px"
          :value.sync="koordinat"
        />
        <Input
          type="text"
          label="Lokasi"
          width="300px"
          :value.sync="forms.LokasiKm"
          prefix="Km"
        />
        <Select
          label="Sebelah"
          width="300px"
          :value.sync="forms.Sebelah"
          :items="[
            { val: 'kanan', txt: 'Kanan Jalan' },
            { val: 'kiri', txt: 'Kiri Jalan' },
          ]"
        />
        <div v-if="!forms.isPotensi">
          <Label label="Luasan">
            <Input
              type="number"
              placeholder="Panjang"
              :value.sync="forms.Panjang"
              postfix="m"
              style="width:100px;"
            />
            <div style="padding:0 5px;">x</div>
            <Input
              type="number"
              placeholder="Lebar"
              :value.sync="forms.Lebar"
              postfix="m"
              style="width:100px"
            />

            <div
              style="padding:0 5px;"
              v-show="forms.JenisPenerimaan == 'reklame'"
            >
              x
            </div>
            <Select
              v-show="forms.JenisPenerimaan == 'reklame'"
              :value.sync="forms.Muka"
              style="width:100px;"
              :items="[
                { val: 1, txt: '1 Muka' },
                { val: 2, txt: '2 Muka' },
              ]"
            />
          </Label>
          <DatePicker label="Mulai Sewa" :value.sync="forms.MulaiSewa" />
          <Input
            type="number"
            postfix="bulan"
            label="Periode Sewa"
            :value.sync="forms.PeriodeSewa"
          />
        </div>
      </div>
      <div class="form-inline" style="width:500px" v-show="tab == 'rekanan'">
        <Label label="Surat Permohonan">
          <Input
            type="text"
            placeholder="Nomor"
            :value.sync="forms.NoPermohonan"
            style="width:170px"
          />
          <DatePicker
            placeholder="Tanggal"
            :value.sync="forms.TglPermohonan"
            postfix="m"
            style="width:130px"
          />
        </Label>
        <Search
          type="text"
          label="Nama Perusahaan"
          dbref="AST_SrcRekanan"
          width="300px"
          :value.sync="forms.RekananId"
          :text.sync="forms.Perusahaan"
          @item-click="RekananChange"
        />
        <Input
          type="text"
          label="Nama Pimpinan"
          width="300px"
          :value.sync="forms.Pimpinan"
        />
        <TextArea
          label="Alamat"
          width="300px"
          :value.sync="forms.AlamatRekanan"
        />
        <Input
          type="text"
          label="No. HP"
          :value.sync="forms.NoHP"
          width="300px"
        />
        <Input
          type="text"
          label="Email"
          :value.sync="forms.Email"
          width="300px"
        />
      </div>
    </div>
  </Modal>
</template>
<script>
import MenuButton from '../../../components/Forms/MenuButton.vue'
export default {
  components: { MenuButton },
  data: () => ({
    tab: 'detail',
    forms: {},
  }),
  props: {
    data: Object,
  },
  computed: {
    koordinat: {
      get() {
        if (this.forms.Lat && this.forms.Lon)
          return this.forms.Lat + ',' + this.forms.Lon
        else return ''
      },
      set(val) {
        let gm = val.match(/@[\d\-.,]+z/)
        if (gm) val = gm[0].replace(/@/, '').replace(/,\d+z$/, '')
        let x = val.split(',')

        this.forms.Lat = x[0]
        this.forms.Lon = x[1]
      },
    },
    title() {
      return (
        (this.forms.PotensiId ? 'UBAH ' : 'TAMBAH ') +
        (this.forms.isPotensi ? 'POTENSI' : 'PENERIMAAN')
      )
    },
  },
  watch: {
    data(val) {
      this.forms = val
    },
    'forms.show'(val) {
      if (val) {
        this.tab = 'detail'
        this.Populate(this.forms.PotensiId)
      }
    },
  },
  mounted() {
    this.Populate(this.forms.PotensiId)
  },
  methods: {
    async Populate(id) {
      let d = await this.$api.call('AST_SelPotensi', {
        PotensiId: id,
      })
      if (d.success) {
        let lonlat = [null, null]
        if (d.data[0].Lokasi) {
          lonlat = d.data[0].Lokasi.replace(/[^\d\s.-]/g, '').split(' ')
        }
        this.forms = {
          ...this.forms,
          ...d.data[0],
          Lat: lonlat[0],
          Lon: lonlat[1],
        }
      }
    },
    async Save() {
      let ret = await this.$api.call('AST.SavPotensi', this.forms)
      if (ret.success) {
        this.forms.show = false
        this.$emit('reload')
      }
    },
    RekananChange(d) {
      if (d) {
        this.forms.RekananId = d.RekananId
        this.forms.Pimpinan = d.Pimpinan
        this.forms.Perusahaan = d.Perusahaan
        this.forms.AlamatRekanan = d.Alamat
      } else {
        this.forms.RekananId = 0
      }
    },
    DownloadDoc(item) {
      let rmap = {
        'Berita Acara': 'berita-acara',
        'Rekomendasi Teknis': 'rekomtek',
        'Perjanjian Kerja Sama': 'perjanjian-kerjasama',
      }
      this.$api.download(
        `/api/asset/template/${rmap[item.text]}?PotensiId=${
          this.forms.PotensiId
        }`
      )
    },
  },
}
</script>
